import React, { useState, useEffect, useRef } from 'react';
import useScores from './Hooks/useScores'; // Adjust this import path to wherever your useScores.js file is located
import { Link } from 'react-router-dom';
import './searchTool.scss';
import { FaSearch } from 'react-icons/fa';

const SearchTool = () => {
    const { searchResults, handleSearch } = useScores();
    const [searchTerm, setSearchTerm] = useState('');

    const searchToolRef = useRef(null);

    const handleDocumentClick = (e) => {
        // Check if the click occurred outside the SearchTool component
        if (searchToolRef.current && !searchToolRef.current.contains(e.target)) {
            // Clear the search term and search results when the user clicks outside
            setSearchTerm('');
            handleSearch(''); // Clear search results by calling handleSearch with an empty string
        }
    };

    useEffect(() => {
        // Add click event listener to the document
        document.addEventListener('click', handleDocumentClick);

        // Clean up the event listener when the component is unmounted
        return () => {
            document.removeEventListener('click', handleDocumentClick);
        };
    }, []); // Empty dependency array ensures the effect runs only once on mount

    return (
        <div ref={searchToolRef} className="relative w-full">
            <div className="relative w-full">
                <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" />
                <input
                    className="w-full pl-12 pr-4 py-3 rounded-xl text-sm sm:text-base bg-white border-2 border-gray-200 transition-all duration-300 focus:outline-none focus:border-purple-500 focus:ring-2 focus:ring-purple-200 hover:border-gray-300 shadow-sm hover:shadow-md"
                    type="text"
                    placeholder="Procure um quiz..."
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        handleSearch(e.target.value);
                    }}
                />
            </div>

            {searchResults.length > 0 && (
                <div className="absolute top-full mt-2 w-full bg-white rounded-xl shadow-xl border-2 border-gray-200 z-50 max-h-96 overflow-y-auto">
                    {searchResults.map((result) => (
                        <Link
                            key={result.id}
                            to={`/quiz/${result.id}`}
                            className="block px-4 py-3 hover:bg-purple-50 border-b border-gray-100 last:border-b-0 transition-colors duration-200"
                        >
                            <div className="flex items-start justify-between gap-3">
                                <div className="flex-1 min-w-0">
                                    <h4 className="font-semibold text-gray-800 text-sm sm:text-base truncate">{result.data.title}</h4>
                                    <div className="flex flex-wrap gap-2 mt-2">
                                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                                            {result.data.level}
                                        </span>
                                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                            {result.data.type}
                                        </span>
                                    </div>
                                    {result.data.description && (
                                        <p className="text-xs text-gray-500 mt-1 line-clamp-1">{result.data.description}</p>
                                    )}
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SearchTool;
